module.exports = __webpack_public_path__ + "static/media/upload.7cd697a6.svg";